import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'fidelitySGAverageChart',
    label: 'Average Fidelity Chart',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
